export type NadoWithdrawSourceSymbol = 'USDC' | 'USDT0';
export type NadoWithdrawDestinationSymbol = 'USDC' | 'USDT';

export interface NadoWithdrawRoute {
  uiSourceSymbol: NadoWithdrawSourceSymbol;
  nadoProductId: 0 | 5;
  inkSourceSymbol: NadoWithdrawSourceSymbol;
  inkInputToken: `0x${string}`;
  destinationChainId: 1;
  destinationSymbol: NadoWithdrawDestinationSymbol;
  destinationOutputToken: `0x${string}`;
  decimals: 6;
  bridgeProvider: 'across';
}

const ETHEREUM_CHAIN_ID = 1;

export const NADO_WITHDRAW_ETHEREUM_ROUTES: Record<
  NadoWithdrawSourceSymbol,
  NadoWithdrawRoute
> = {
  USDC: {
    uiSourceSymbol: 'USDC',
    nadoProductId: 5,
    inkSourceSymbol: 'USDC',
    inkInputToken: '0x2D270e6886d130D724215A266106e6832161EAEd',
    destinationChainId: ETHEREUM_CHAIN_ID,
    destinationSymbol: 'USDC',
    destinationOutputToken: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    decimals: 6,
    bridgeProvider: 'across',
  },
  USDT0: {
    uiSourceSymbol: 'USDT0',
    nadoProductId: 0,
    inkSourceSymbol: 'USDT0',
    inkInputToken: '0x0200C29006150606B650577BBE7B6248F58470c1',
    destinationChainId: ETHEREUM_CHAIN_ID,
    destinationSymbol: 'USDT',
    destinationOutputToken: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    decimals: 6,
    bridgeProvider: 'across',
  },
};

function isNadoWithdrawSourceSymbol(
  symbol: string,
): symbol is NadoWithdrawSourceSymbol {
  return symbol === 'USDC' || symbol === 'USDT0';
}

export function getNadoWithdrawRoute({
  selectedChainId,
  selectedTokenSymbol,
}: {
  selectedChainId: number;
  selectedTokenSymbol: string;
}): NadoWithdrawRoute | undefined {
  if (selectedChainId !== ETHEREUM_CHAIN_ID) {
    return undefined;
  }
  if (!isNadoWithdrawSourceSymbol(selectedTokenSymbol)) {
    return undefined;
  }
  return NADO_WITHDRAW_ETHEREUM_ROUTES[selectedTokenSymbol];
}

export function getNadoWithdrawDestinationSymbol(
  selectedTokenSymbol: string,
  selectedChainId: number,
): NadoWithdrawDestinationSymbol | undefined {
  return getNadoWithdrawRoute({
    selectedChainId,
    selectedTokenSymbol,
  })?.destinationSymbol;
}
